module.exports = __webpack_public_path__ + "static/media/Finance-02.4f97ab90.svg";